// /instance.js

import axios from "axios";
import qs from "qs";
import { hostName } from "../config/config";

const instance = axios.create({
  baseURL: hostName,
  paramsSerializer(params) {
    return qs.stringify(params, { indices: false });
  },
});

instance.interceptors.request.use(
  (config) => {
    let userObj = localStorage.getItem("persist:root") || "";
    let parseData = JSON.parse(userObj);
    let parseUser = JSON.parse(parseData?.user);

    let token = parseUser?.userObj?.token ? parseUser.userObj.token : "";
    config.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response;
    } else {
      const messages = response.data.messages;
      if (messages) {
        if (messages instanceof Array) {
          return Promise.reject({ messages });
        }
        return Promise.reject({ messages: [messages] });
      }
      return Promise.reject({ messages: ["got errors"] });
    }
  },
  (error) => {
    if (error?.response && error?.response?.status === 401) {
      if (error?.response?.data?.message === "Invalid credentials.") {
        return Promise.reject(error?.response);
      }
      localStorage.removeItem("token");
      window.location.href = "/";
      return;
    } else if (error?.response && error?.response?.status === 500) {
      return Promise.reject(error.response);
    } else return Promise.reject(error.response);
  }
);

export const http = instance;

export default http;
